// extracted by mini-css-extract-plugin
export default {"title":"styles_title__syDhY","subtitle":"styles_subtitle__7-+ny","blurb":"styles_blurb__Aujv1","home":"styles_home__dlyDK"};